import { Preferences } from "@capacitor/preferences";
import { useQuery } from "react-query";

export const useCookieQuery = (key: string) => {
  return useQuery({
    queryKey: ["getCookieQuery"],
    queryFn: async () => {
      let response = await Preferences.get({ key });
      return JSON.parse(response.value as string);
    },
  });
};
